module.exports = __webpack_public_path__ + "media/images/nav_icons/homeicon_root-b14f132e3ffef3f2b9ec93c2537aee40.png";